import React from 'react';
import { useForm } from '@inertiajs/inertia-react';
import TextInput from '@/Shared/TextInput';
import LoadingButton from '@/Shared/LoadingButton';

const FindCouponModal = ({ categoryId }) => {
  const { data, setData, errors, post, processing } = useForm({
    coupon_id: 0,
    cat_order: 0
  });

  const handleSubmit = e => {
    e.preventDefault();
    post(route('categories.add.coupon', categoryId).url());
  };

  return (
    <form onSubmit={handleSubmit}>

      <div className='flex flex-wrap p-8 -mb-8 -mr-6'>

        <TextInput
          className='w-full pb-8 pr-6 lg:w-1/2'
          label='Find coupon by id'
          name='coupon_id'
          type='number'
          errors={errors.coupon_id}
          value={data.coupon_id}
          onChange={e => setData('coupon_id', e.target.value)}
        />
        <TextInput
          className='w-full pb-8 pr-6 lg:w-1/2'
          label='Order'
          name='cat_order'
          type='number'
          errors={errors.cat_order}
          value={data.cat_order}
          onChange={e => setData('cat_order', e.target.value)}
        />
        <span className='mb-4'>
        Note: Only published coupons can be added to categories.
      </span>
        <LoadingButton
          loading={processing}
          type='submit'
          className='btn-default  self-center mb-4'
        >
          Add coupon
        </LoadingButton>
      </div>
    </form>
  );
};

export default FindCouponModal;
